import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-118" data-mp="hv7hddkf0t1u">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-orange/10 blur-3xl" aria-hidden="true" data-id="element-119" data-mp="muty3wzgcrfe" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-120" data-mp="vmm0rli8iw9f">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-121" data-mp="10lypycwkwff6">
          <SectionTag icon="🏀" data-id="element-122" data-mp="15lbcewjjfkh8">Para entrenadores que quieren dejar de improvisar</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-bold uppercase leading-[1.08] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-123" data-mp="1ako8m7wau3wh">
          Todo tu año de <span className="text-orange" data-id="element-124" data-mp="3vvslp3vq8hj3">Baloncesto</span> resuelto.
        </m.h1>

        {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
        <img src="https://cdn.magicpatterns.com/uploads/6kf9vNt6znqLgPhjPdfDgA/mockup_baloncesto_webp_450x450.webp" alt="El Manual del Entrenador de Baloncesto: colección de 6 tomos y 5 bonos" width={450} height={450} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-xs sm:max-w-sm" data-id="element-125" data-mp="sek50ncqjnpy" />

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-126" data-mp="1b51yiu5e6ncd">
          Ten siempre una sesión lista para llevar a pista, aunque sea domingo a las 10 de la noche y
          todavía no hayas preparado nada. El Manual del Entrenador de Baloncesto reúne 6 tomos y 180
          sesiones reales <span className="font-semibold text-white" data-id="element-127" data-mp="2vv79f02f2e3l">"Sesión en Mano"</span> para que abras
          el PDF, veas el ejercicio y sepas exactamente qué hacer en tu próximo entrenamiento.
        </m.p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.26
      }} className="mt-7 flex flex-col items-center" data-id="element-128" data-mp="2muivs6gxqfr8">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-129" data-mp="2cvtcqadayp9e">Quiero el Manual por 19€</PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-130" data-mp="65n4glpri6qw">
            Acceso inmediato · Formato digital · Úsalo desde móvil, tablet u ordenador
          </p>
        </m.div>

        <m.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.34
      }} className="mt-6 flex flex-col items-center gap-2 text-sm text-muted sm:flex-row sm:gap-4" data-id="element-131" data-mp="1vmr2aa2a5tuc">
          <div className="flex items-center gap-2" data-id="element-132" data-mp="25eeonwjzckoy">
            <StarRating data-id="element-133" data-mp="20mdf4ie7582m" />
            <span className="font-medium text-white" data-id="element-134" data-mp="20l2bcikr40bi">4.9/5</span>
            <span data-id="element-135" data-mp="2ed8gl9md8mw6">· +500 reseñas verificadas</span>
          </div>
          <div className="hidden h-4 w-px bg-white/15 sm:block" aria-hidden="true" data-id="element-136" data-mp="2ebp29ok9slx1" />
          <div className="flex items-center gap-1.5 text-orange" data-id="element-137" data-mp="2abdgg8g68fjz">
            <FlameIcon size={16} className="fill-orange" data-id="element-138" data-mp="2oby0t91qijfl" />
            <span data-id="element-139" data-mp="2o9bu1bmo47yf">38 entrenadores eligieron este Manual hoy</span>
          </div>
        </m.div>
      </div>
    </header>;
}